/**
 * Primary context for sites. Provides three keys:
 *   market: outdoor|urban|leaf
 *   country: ca|us|de|...
 *   language: en|fr|es|...
 *
 * All values are expected to be lowercase.
 */

import React from "react";
export const SiteContext = React.createContext({});
export const SiteContextProvider = ({ children, market, country, language }) => (
  <SiteContext.Provider value={{ market, country, language }}>{children}</SiteContext.Provider>
);
export const SiteContextConsumer = SiteContext.Consumer;
